import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  computed,
  input,
  output,
} from '@angular/core';
import { PAGE, TAB } from '@constants/constants';
import { AbbCommonModule } from 'app/abb-common.module';
import { AbbTabsComponent } from '@components/abb-tabs/abb-tabs.component';
import { CommonModule } from '@angular/common';
import { TPipe } from '@pipes/t.pipe';
import { PermissionsService } from '@services/user/permissions.service';

@Component({
  selector: 'page-layout',
  standalone: true,
  template: `
    <div
      class="flex flex-col flex-1 min-h-0"
      [ngClass]="tabs ? 'gap-2' : 'gap-6'"
    >
      <div class="flex flex-row items-center justify-between pr-6">
        <span class="flex flex-col">
          @if(!titleRef && title()) {
          <span
            class="text-xl/8 font-semibold text-abb-primary leading-none p-0 m-0"
            >—</span
          >}
          <h1 class="text-abb-font text-xl/8 font-semibold min-h-9">
            <ng-content #titleRef select="[title]" />
            @if(!titleRef) {
            <span>{{ title()?.slice(0, 3) }}</span
            >{{ title()?.slice(3) }}
            }
          </h1>
          <h2 class="text-abb-font/60 text-sm/4 font-semibold">
            <ng-content #subtitleRef select="[subtitle]" />
            @if(!subtitleRef) {
            {{ subtitle() | t }}
            }
          </h2>
        </span>
        <div class="flex gap-x-2">
          <ng-content select="abb-button"></ng-content>
        </div>
      </div>
      <div class="flex flex-col w-full min-h-0 flex-1 overflow-auto pr-2">
        @if(tabs) {
        <abb-tabs
          class="flex flex-col w-full flex-1 overflow-hidden gap-6"
          [tabs]="tabs"
          [canEdit]="canEdit()"
          (tabChange)="tabChange($event)"
        ></abb-tabs>
        } @else {
        <ng-content></ng-content>
        }
      </div>
    </div>
  `,
  host: {
    class: 'flex flex-col flex-1 min-h-0 overflow-hidden pl-6 pb-3',
  },
  styles: ``,
  imports: [CommonModule, AbbCommonModule, AbbTabsComponent, TPipe],
})
export class LayoutComponent implements OnInit {
  @ViewChild('titleRef') titleRef: ElementRef | undefined;
  @ViewChild('subtitleRef') subtitleRef: ElementRef | undefined;
  page = input.required<PAGE>();
  title = input<string | undefined>();
  subtitle = input<string | undefined>();
  tabchange = output<string>();
  tabs: Array<TAB> | undefined;
  canEdit = computed(() => this.permissionsService.canEditPage(this.page()));

  constructor(private readonly permissionsService: PermissionsService) {}

  ngOnInit(): void {
    this.tabs = this.page()?.tabs;
  }

  tabChange(tab: string) {
    this.tabchange.emit(tab);
  }
}
